import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/search_camera.svg'


const _withScopeId = n => (_pushScopeId("data-v-d5c21ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  for: "reload_image",
  class: "flex-ter cursor-pt search_camera"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import { bury } from '@/util/useBury'
import { searchByImage } from '@/util/useSearchByImage'


export default /*#__PURE__*/_defineComponent({
  props: ['imageUrl'],
  setup(__props) {

const props = __props


// 图搜
const uploadImageRef = ref()

return (_ctx: any,_cache: any) => {
  return (__props.imageUrl)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "image-search-goods flex-ter",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(bury)('ALL_Click_SearchByImage')))
      }, [
        _createElementVNode("img", {
          src: __props.imageUrl,
          alt: "",
          class: "productImg"
        }, null, 8, _hoisted_1),
        _createElementVNode("label", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('重新上传图片搜索')), 1),
          _withDirectives(_createElementVNode("input", {
            id: "reload_image",
            type: "file",
            ref: (_value, _refs) => {
              _refs['uploadImageRef'] = _value
              uploadImageRef.value = _value
            },
            accept: "image/gif,image/png,image/jpeg,image/bmp,image/jpg",
            onChange: _cache[0] || (_cache[0] = (e)=>{_unref(searchByImage)(e.target.files[0]);uploadImageRef.value.value = ''})
          }, null, 544), [
            [_vShow, false]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})